import { Helmet } from "react-helmet-async";
import { SITE_URL } from "@/const";
import { TRADING_NAME } from "@/constants/company";

type ArticleJsonLdProps = {
  headline: string;
  datePublished?: string | null;
  author: string;
  image?: string | null;
  description?: string | null;
  url: string;
};

export default function ArticleJsonLd({
  headline,
  datePublished,
  author,
  image,
  description,
  url,
}: ArticleJsonLdProps) {
  const data = {
    "@context": "https://schema.org",
    "@type": ["BlogPosting", "Article"],
    headline,
    datePublished: datePublished ?? undefined,
    description: description ?? undefined,
    image: image ?? undefined,
    url,
    author: {
      "@type": "Person",
      name: author,
    },
    publisher: {
      "@type": "Organization",
      name: TRADING_NAME,
      url: SITE_URL,
    },
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
}
